import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isLogged = await this.authService.isLoggedAsync();

    if (!isLogged) {
      this.router.navigate(['/login'], {
        queryParams: { returnUrl: state.url },
      });

      return false;
    }

    return true;
  }
}
